import React from 'react';
import { Dialog } from '@material-ui/core';
import PropTypes from 'prop-types';

import { T, FONT_MONO } from '../constants/tokens';

/**
 * The v7 dialog: an eyebrow with a status dot, a 32px title, a body, and
 * right-aligned actions on a white card behind a scrim.
 *
 * Every confirmation in the app goes through this so they cannot drift.
 * Built on MUI's Dialog rather than a bare fixed div so focus trapping,
 * escape-to-close and scroll locking come for free.
 */
export default function Modal({
  open,
  onClose,
  eyebrow = null,
  dotColor = null,
  title,
  body = null,
  children = null,
  actions = null,
  width = 520
}) {
  return (
    <Dialog
      open={!!open}
      onClose={onClose}
      maxWidth={false}
      aria-label={typeof title === 'string' ? title : undefined}
      PaperProps={{
        style: {
          width: 'min(' + width + 'px, 100%)',
          margin: 24,
          borderRadius: 8,
          border: '1px solid ' + T.hairline,
          background: T.elevated
        }
      }}
    >
      <div style={{ padding: 32 }}>
        {eyebrow &&
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
            {dotColor &&
              <span style={{ width: 8, height: 8, borderRadius: 9999, background: dotColor, flex: 'none' }} />}
            <span
              style={{
                fontFamily: FONT_MONO,
                fontSize: 12,
                fontWeight: 500,
                lineHeight: '16px',
                textTransform: 'uppercase',
                color: T.body
              }}
            >
              {eyebrow}
            </span>
          </div>}

        <h2
          style={{
            margin: '0 0 12px',
            fontSize: 32,
            fontWeight: 600,
            lineHeight: '40px',
            letterSpacing: '-1.28px',
            color: T.ink,
            textWrap: 'pretty'
          }}
        >
          {title}
        </h2>

        {body &&
          <p style={{ margin: '0 0 24px', fontSize: 16, lineHeight: '24px', color: T.body, textWrap: 'pretty' }}>
            {body}
          </p>}

        {children}

        {actions &&
          <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-end', gap: 12 }}>
            {actions}
          </div>}
      </div>
    </Dialog>
  );
}

Modal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  eyebrow: PropTypes.node,
  dotColor: PropTypes.string,
  title: PropTypes.node.isRequired,
  body: PropTypes.node,
  children: PropTypes.node,
  actions: PropTypes.node,
  width: PropTypes.number
};
